export default "__VITE_ASSET__DWlHEpGb__"